import type { SchemaPartnerResolver_GetMyPartnerContact } from 'cpool-tables/backend-resolvers';
import { useTranslation } from 'react-i18next';

import { PartnerContactListItem } from './PartnerContactListItem';

type Props = {
    contacts: Array<SchemaPartnerResolver_GetMyPartnerContact>;
    disabled: boolean;
    disabledReason?: string;
    onContactClick: (contact: SchemaPartnerResolver_GetMyPartnerContact) => void;
};

export const ContactRows = ({ contacts, disabled, disabledReason, onContactClick }: Props) => {
    const { t } = useTranslation();

    return (
        <div className="flex flex-col gap-1 px-4 pb-3">
            <div className="pb-1 pt-3 text-sm font-semibold text-midnight">
                {t('WHATSAPP_CHAT.LIST.CONTACTS_SECTION')}
            </div>
            {contacts.map((contact) => (
                <PartnerContactListItem
                    key={contact.id}
                    contact={contact}
                    disabled={disabled}
                    disabledReason={disabledReason}
                    onClick={() => onContactClick(contact)}
                />
            ))}
        </div>
    );
};
